import React, { useEffect, useState } from 'react';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import { isMobile } from 'lib/utils/UiUtils';
import CustomBarHorizontalController from './CustomBarHorizontalController';
import { barThickness } from '../utils';

// @NOTE: https://www.chartjs.org/docs/latest/charts/bar.html
// @NOTE: https://www.chartjs.org/docs/latest/axes/styling.html#grid-line-configuration
// @NOTE: props (mobile, taller) here, old code. For syling that we may use or do differently
const BarGraphHorizontal = (props) => {
    const [isGraphInitialized, setIsGraphInitialized] = useState(false);
    const [graphReady, setGraphReady] = useState(false);
    const [chart, setChart] = useState(undefined);
    const chartEl = React.createRef();
    const mobile = isMobile();

    let data = props.data;
    let dailyGoal = props.dailyTarget || (props.target / props.monthLength);
    let maxValue = chart ? chart.scales.x.max : props.target;
    let maxHeight = chart ? chart.scales.y.maxHeight : 0;
    let maxWidth = chart ? chart.scales.x.maxWidth : 0;

    const updateData = (d, _d, i, ctx) => {
        let perc = _d / dailyGoal;
        let color = '';
        let aboveColor = props.options.swapped ? 'rgba(98, 63, 234, 1)' : 'rgba(102, 255, 204, 1)';
        let belowColor = props.options.swapped ? 'rgba(102, 255, 204, 1)' : 'rgba(98, 63, 234, 1)';

        function makeGradient(dVal, pos, data) {
            let yPos = (pos/data.data.length) * maxHeight; // verify?
            let xEnd = maxWidth * (dVal / maxValue);
            let gradient = ctx.createLinearGradient(0, yPos, xEnd, yPos+barThickness());

            // @NOTE: Real colors, idk why this gradient won't draw. Put in temp color for now
            gradient.addColorStop(0, 'rgba(102, 255, 204, 1)'); // aqua
            gradient.addColorStop(1, 'rgba(98, 63, 234, 1)'); // purple (goes purple -> aqua on the design)
            //gradient.addColorStop(0, 'rgb(124, 252, 0, 1)'); // green temp

            return gradient;
        }

        if (_d >= dailyGoal) {
            color = aboveColor;
            // if within 10% show gradient
            if (perc <= 1.1 && props.swapped) {
                color = makeGradient(_d, i, d);
            }
        } else {
            color = belowColor;
            // if within 10% show gradient
            if (perc >= .9 && !props.swapped) {
                color = makeGradient(_d, i, d);
            }
        }

        d.backgroundColor[i] = color;
        d.hoverBackgroundColor[i] = color;
    }

    useEffect(() => {
        Chart.register(...registerables);
        Chart.register(annotationPlugin);
        Chart.register(CustomBarHorizontalController);

        Chart.defaults.elements.bar.borderRadius = mobile ? 5 : 10;
        Chart.defaults.elements.bar.pointRadius = mobile ? 5 : 10;
        Chart.defaults.elements.bar.barThickness = mobile ? 5 : 10;
        Chart.defaults.scale.ticks.padding = mobile ? 10 : 20;
        Chart.defaults.layout.padding.left = 0;
        Chart.defaults.color = 'rgba(255,255,255,1)';
        Chart.defaults.font.family = "'sans-serif', 'arial'";
        Chart.defaults.font.size = mobile ? 12 : 16;

        if (data && chartEl.current && !isGraphInitialized && props.dataReady && !chart) {
            let canvas = chartEl.current;
            let ctx = canvas.getContext('2d');

            if (chart) {
                chart.destroy();
            }

            setChart(new Chart(ctx, { type: 'CustomBarHorizontal', data, options: props.options}));

            setIsGraphInitialized(true);
        }
    }, [props.data, props.dataReady]);

    // modify data and update chart, after it's been created
    useEffect(() => {
        if (chartEl.current && chart) {
            let ctx = chartEl.current.getContext('2d');
            maxValue = chart.scales.x.max;
            maxHeight = chart.scales.x.maxHeight; // these are reversed for X and Y scales, but same values...
            maxWidth = chart.scales.x.maxWidth;

            // update data gradients now that we have correct canvas height:
            chart.data.datasets.forEach((d) => {
                d.backgroundColor = [];
                d.hoverBackgroundColor = [];
                d.data.forEach((_d, i) => {
                    updateData(d, _d, i, ctx);
                });
            });

            chart.update();

            if (chart.scales.y && props.mobile) {
                setGraphReady(true);
            }

            if (!props.mobile) {
                setGraphReady(true);
            }
        }
    }, [props.data, chart]);

    useEffect(() => {
        return () => {
            if (chart) {
                chart.destroy();
                setChart(null);
                setIsGraphInitialized(false);
            }
        }
    }, []);

    return (
        <div className={ 'graph-container bar-graph-horizontal' + (props.mobile ? ' mobile' : '') + (graphReady ? ' ready' : '')}>
            {!props.mobile && <div className="header">{ props.header}</div>}

            <div className={'graph horizontal ' + (props.taller ? 'taller' : '')} key={props.name}>
                <canvas id="chartjs-graph" key={props.name + "-canvas"} width="100%" height="auto" ref={chartEl} />
            </div>
        </div>
    )
}

export default BarGraphHorizontal
